import { FC } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface GoogleFontIconProps {
  name: string;
  sx?: SxProps<Theme>;
}

const GoogleFontIcon: FC<GoogleFontIconProps> = ({ name, sx }) => (
  <Box
    component="span"
    className="material-symbols-outlined notranslate"
    sx={{ fontSize: 'inherit', lineHeight: 1, ...sx }}
  >
    {name}
  </Box>
);

export default GoogleFontIcon;
